<template>
  <main class="check-user-page">
    <section class="container">
      <div class="full-height-wrap">
        <card-form>
          <check-user :is-mobile="isMobile"/>
        </card-form>
      </div>
    </section>
  </main>
</template>

<script>
import CardForm from '../components/CardForm/CardForm';
import CheckUser from '../layouts/CheckUser/CheckUser';

export default {
  name: 'EventsPage',
  components: {
    CheckUser,
    CardForm,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
